// extracted by mini-css-extract-plugin
export default {"container":"CheckboxAndLabel_container__vAhaC"};